import React, { useEffect, useState } from "react";
import { Smartphone, X, Download } from "lucide-react";

const STORAGE_KEY = "afb-pwa-prompt-dismissed";

export default function InstallAppPrompt() {
  const [deferred, setDeferred] = useState(null);
  const [visible, setVisible] = useState(false);
  const [isIos, setIsIos] = useState(false);

  useEffect(() => {
    if (sessionStorage.getItem(STORAGE_KEY)) return;
    if (window.matchMedia("(display-mode: standalone)").matches) return;

    const ua = window.navigator.userAgent;
    const ios = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    setIsIos(ios);

    const onPrompt = (e) => {
      e.preventDefault();
      setDeferred(e);
      setTimeout(() => setVisible(true), 4000);
    };
    window.addEventListener("beforeinstallprompt", onPrompt);

    // iOS doesn't fire beforeinstallprompt — show manual hint
    if (ios) setTimeout(() => setVisible(true), 6000);

    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, []);

  const install = async () => {
    if (deferred) {
      deferred.prompt();
      await deferred.userChoice;
      setDeferred(null);
    }
    dismiss();
  };

  const dismiss = () => {
    setVisible(false);
    sessionStorage.setItem(STORAGE_KEY, "1");
  };

  if (!visible || (!deferred && !isIos)) return null;

  return (
    <div
      className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:w-[360px] z-50 bg-[#0A1F44] text-white rounded-2xl shadow-2xl border border-[#D4AF37]/40 p-5 flex gap-4 items-start"
      data-testid="install-app-prompt"
    >
      <div className="w-11 h-11 rounded-xl bg-[#D4AF37] grid place-items-center text-[#0A1F44] shrink-0">
        <Smartphone size={20} />
      </div>
      <div className="flex-1 min-w-0">
        <div className="font-display text-base">Installer A.F.B.</div>
        <p className="text-xs text-white/75 mt-1 leading-relaxed">
          {isIos
            ? "Ajoutez A.F.B. à votre écran d'accueil : appuyez sur Partager puis « Sur l'écran d'accueil »."
            : "Ajoutez l'app A.F.B. à votre écran d'accueil pour un accès direct, hors-ligne et sans navigateur."}
        </p>
        {!isIos && deferred && (
          <button
            onClick={install}
            className="mt-3 inline-flex items-center gap-2 px-4 py-2 rounded-md bg-[#D4AF37] text-[#0A1F44] text-xs font-bold uppercase tracking-wider hover:bg-[#B5952F]"
            data-testid="install-app-btn"
          >
            <Download size={13} /> Installer
          </button>
        )}
      </div>
      <button
        onClick={dismiss}
        className="text-white/50 hover:text-white shrink-0"
        data-testid="install-dismiss"
        aria-label="Fermer"
      >
        <X size={16} />
      </button>
    </div>
  );
}
